import { PaymentReceiptWithoutTokenPage } from '@/features/payment-receipt';
import { createFileRoute } from '@tanstack/react-router';

/**
 * `/payment` sem o token, para onde voltam os pedidos criados quando a página
 * de retorno do produto estava preenchida com esse endereço. Pública, como o
 * comprovante (`$token.tsx`).
 */
export const Route = createFileRoute('/payment/')({
  component: PaymentReceiptWithoutTokenPage,
});
